
import _ from 'lodash';
import { useEffect, useState } from 'react';
import MarketPlacePolicyProductComponent from './market-place-policy-product.component';
import MarketPlacePolicyVendorComponent from './market-place-policy-vendor.component';
import MarketPlacePolicyCategoryComponent from './market-place-policy-category.component';
import Popup from '../../../../../common/components/popup';
import Table from '../../../../../common/components/table';

export const MarketPlacePolicyDetailsComponent = ({
  id,
  selectedPolicyCollections,
  setSelectedPolicyCollections,
  columnDefs,
  rowData,
  onDelete,
  categories,
  products,
  vendors
}: any) => {
  console.log('rowData', rowData, 'products', products, 'categories', categories, 'vendors', vendors)
  console.log('selectedPolicyCollections', selectedPolicyCollections)
  const [showMappingDialog, setShowMappingDialog] = useState<boolean>(false);
  const [currentEntityType, setCurrentEntityType] = useState<string>();
  const [selectedData, setSelectedData] = useState<any>(rowData);

  const closeModal = () => {
    setShowMappingDialog(false)
  }

  const LoadMappedCollections = () => {
    switch (selectedPolicyCollections?.MarketplaceTypeId) {
      case 4: //categories
        setCurrentEntityType('Categories');
        return (
          <Popup onClose={closeModal}>
            <MarketPlacePolicyCategoryComponent 
                id={id}
                selectedPolicyCollections={selectedPolicyCollections}
                setSelectedPolicyCollections={setSelectedPolicyCollections}
                categories={categories}
                setSelectedCategories={setSelectedData}
                closeModal={closeModal}            
            />
          </Popup>
        )
      case 3: //products
      setCurrentEntityType('Products')
        return (
          <Popup onClose={closeModal}>
            <MarketPlacePolicyProductComponent 
                id={id}
                selectedPolicyCollections={selectedPolicyCollections}
                setSelectedPolicyCollections={setSelectedPolicyCollections}
                products={products}
                setSelectedProducts={setSelectedData}
                closeModal={closeModal}            
            />
          </Popup>
        )
      case 41: //vendors
      setCurrentEntityType('Vendors')
        return (
          <Popup onClose={closeModal}>
            <MarketPlacePolicyVendorComponent
              id={id}
              selectedPolicyCollections={selectedPolicyCollections}
              setSelectedPolicyCollections={setSelectedPolicyCollections}
              vendors={vendors}
              setSelectedVendors={setSelectedData}
              closeModal={closeModal}
            />
          </Popup>
        )
    }
  }

  useEffect(() => {
    switch (selectedPolicyCollections?.MarketplaceTypeId) {
      case 4: //categories
        setCurrentEntityType('Categories');
        break;
      case 3: //products
        // setColumnDefs(productColumDefs());
        // setSelectedData(_.filter(products, (item) => _.includes(rowData, item.EntityId)));
        setCurrentEntityType('Products');
        break;
      case 41: //vendors
        setCurrentEntityType('Vendors')
        break;
    }
  }, []);

  return (
    <>
            {selectedPolicyCollections && <><div className='flex flex-row w-full justify-end px-4'>
              <button
                className="mt-5 bg-primary text-light rounded font-semibold px-4 py-3 w-80"
                onClick={() => { setShowMappingDialog(true) }}
                type="button"
              >
                {`Add New ${currentEntityType} Collection`}
              </button>
            </div>
         
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              {showMappingDialog ? <LoadMappedCollections /> : <></>}
             
              <div className='col-span-full'>
                {selectedData && <Table 
                  key={selectedData}
                  columnData={columnDefs} 
                  rowData={selectedData}
                  onDelete={onDelete}
                  headingName={currentEntityType} 
                />}
                 {!selectedData && <Table 
                  columnData={columnDefs} 
                  rowData={rowData}
                  onDelete={onDelete}
                  headingName={currentEntityType} 
                />}

                {/* {selectedPolicyCollections?.CollectionTypeId === 4 && selectedData && <Table 
                  columnData={columnDefs} 
                  rowData={selectedData}
                  headingName={currentEntityType} 
                />} */}
              </div>
            </div></>}
          </>
  )
}
export default MarketPlacePolicyDetailsComponent;
